// 循环调用接口查看是否完成付款
export default function() {
	let _this = this;
	return {
		isPayDone (token,url,type) {
			return new Promise((resolve,reject)=>{
			    _this.$ajax.post(_this.G_uri + '/wechatpay/isPayDone',{
		            type: type,
		        },{
		        	timeout: 1500,
		            headers:{
		                token: token
		            }
		        })
		        	.then((res) =>{
		        		resolve(res);
		        	})	
		        	.catch((error)=> {
		        		reject(error);
		        	})
		    })
		}
	}
}
